export const fabricColors = ['red','orange','yellow','green', 'blue', 'purple', 'pink', 'brown', 'black', 'white']
